// Thank's IE8 for his funny defineProperty
module.exports = !require(45)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});